// Scores lower_name against a space-separated search_key: builds a single
// regex requiring each word to appear, in order, with .*? (lazy wildcard
// match) between each word. Take the indices of each match and return the
// negative sum, so matches nearer the front of the string score higher.
// A return value of null means no match.
export const fuzzy_word_search = (lower_name, search_key) => {
  // Build regex from search words by escaping all special characters.
  const escape_regex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const words = search_key.toLowerCase().trim().split(/\s+/).filter(Boolean);
  const pattern = words.map(word => `(${escape_regex(word)})`).join(".*?");
  // d = just get indices of matches.
  const match = new RegExp(pattern, "d").exec(lower_name);
  if (!match) return null;
  // Skip indices[0] (the whole match) and sum each word's start position.
  const sum = match.indices.slice(1).reduce((acc, [start]) => acc + start, 0);
  return -sum;
};

// The co-voyager count for a person, either over all of their trips or over just
// the ones the filter leaves in. person_trip.in_filter means "this person and
// this trip are both in the filter", so it is the only flag either level checks.
export const count_covoyagers = (person, filtered) => {
  // Keyed by the people themselves rather than by person_index, since this also
  // runs while the default ordering - and so person_index - is still being
  // worked out.
  let covoyagers = new Map();
  for (let i in person.person_trips) {
    if (filtered && !person.person_trips[i].in_filter) continue;
    const trip = person.person_trips[i].trip;
    for (let j in trip.person_trips) {
      if (filtered && !trip.person_trips[j].in_filter) continue;
      const covoyager = trip.person_trips[j].person;
      covoyagers.set(covoyager, (covoyager === person) ? covoyager.group_size - 1 : covoyager.group_size);
    }
  }
  return [...covoyagers.values()].reduce((a,b) => a+b, 0);
};

// Wrap a callback to achieve the same effect
// but without propagation. Or just pass this
// function into an event handler, e.g. onClick,
// to stop any further propagation
export const no_propagate = (arg) => {
    if (typeof arg === "function") {
        const callback = arg;
        // If called with a callback, alter the callback and return it.
        const callback_without_propagate = (e) => {
            e.stopPropagation();
            callback()
        }
        return callback_without_propagate;
    } else {
        // As a bare function, arg is an event
        const e = arg;
        e.stopPropagation();
    }
}
